export default function() {
  /* 表格列头：统一用 min-width，剩余宽度按内容长度比例分配，整行铺满、间隔均匀 */
  return [
    { label: "序号", type: "index", minWidth: 70 },
    { label: "创建人ID", prop: "admin_id", slots: "admin_id", minWidth: 130 },
    { label: "店铺ID", prop: "store_id", minWidth: 90 },
    { label: "店铺名称", prop: "store_name", slots: "store_name", minWidth: 150 },
    { label: "店长", prop: "boss_name", minWidth: 90 },
    { label: "手机号", prop: "store_phone", minWidth: 130 },
    /* 地址较长，用 min-width 吸收剩余宽度 */
    { label: "地址", prop: "store_addr", slots: "store_addr", minWidth: 220 },
    {
      label: "营业时间",
      prop: "workTime",
      slots: "workTime",
      minWidth: 130,
    },
    {
      label: "创建时间",
      prop: "create_time",
      minWidth: 180,
    },
    {
      label: "操作",
      prop: "operation",
      minWidth: 180,
      slots: "operation",
    },
  ];
}
